/**
 * SF32 — Transcription Redaction Policy
 * ट्रांसक्रिप्शन रिडैक्शन — PII और sensitive data categories
 */
const REDACTION_RULES = Object.freeze([
    Object.freeze({
        category: 'phone',
        pattern: 'regex: phone number patterns',
        replacement: '[PHONE_REDACTED]',
        description: 'phone numbers redact होंगे',
    }),
    Object.freeze({
        category: 'email',
        pattern: 'regex: email patterns',
        replacement: '[EMAIL_REDACTED]',
        description: 'email addresses redact होंगे',
    }),
    Object.freeze({
        category: 'address',
        pattern: 'regex: address patterns',
        replacement: '[ADDRESS_REDACTED]',
        description: 'physical addresses redact होंगे',
    }),
    Object.freeze({
        category: 'date_of_birth',
        pattern: 'regex: date of birth patterns',
        replacement: '[DOB_REDACTED]',
        description: 'date of birth redact होगा',
    }),
    Object.freeze({
        category: 'exact_birth_time',
        pattern: 'regex: exact birth time patterns',
        replacement: '[BIRTH_TIME_REDACTED]',
        description: 'exact birth time redact होगा',
    }),
    Object.freeze({
        category: 'customer_full_name',
        pattern: 'regex: full name patterns',
        replacement: '[NAME_REDACTED]',
        description: 'customer full name redact होगा',
    }),
    Object.freeze({
        category: 'api_key_token',
        pattern: 'regex: API key/token patterns',
        replacement: '[TOKEN_REDACTED]',
        description: 'API key/token-like text redact होगा',
    }),
]);
export const TRANSCRIPTION_REDACTION_SF32 = Object.freeze({
    version: '0.1.101',
    rules: REDACTION_RULES,
    redactBeforePersist: true,
    redactBeforeDisplay: true,
    auditRedactionEvent: true,
    categoriesCount: REDACTION_RULES.length,
});
//# sourceMappingURL=transcriptionRedactionSf32.js.map